import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { restRequestMultiple } from 'common-src/features/rest/actions';
import {
  catchReferralErrors,
  extractPatientReferral,
  getPatientReferrals,
  hasDuplicateReferrals,
} from 'common-src/models/PatientReferral';

import { Referrals as ReferralsForm } from 'src/components/forms';
import useAlert from 'src/hooks/useAlert';
import useCustomSelector from 'src/hooks/useCustomSelector';
import useFormButtons from 'src/hooks/useFormButtons';

import { getReferralRequests } from './helpers';

const Referrals = ({ patientId }) => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState([]);

  const referrals = useCustomSelector((state) => getPatientReferrals(state, patientId));

  const { showAlert, AlertType } = useAlert();

  const onSubmitHandler = (setIsLoading, setIsEditMode, handleErrors) => {
    const { errors, hasErrors } = catchReferralErrors(formData);
    if (hasErrors) {
      handleErrors(errors);
      return;
    }

    if (hasDuplicateReferrals(formData)) {
      showAlert(AlertType.Error, '', 'Duplicate referrals found');
      return;
    }

    setIsLoading(true);
    dispatch(
      restRequestMultiple({
        restRequests: getReferralRequests(formData, referrals),
        successBlock: () => {
          setIsEditMode(false);
          setIsLoading(false);
          showAlert(AlertType.Success, '', 'You have successfully updated referrals.');
        },
        errorBlock: (err) => {
          setIsLoading(false);
          showAlert(AlertType.Error, '', err);
        },
      }),
    );
  };

  const onEditHandler = () => {
    setTimeout(() => {
      const element = document.getElementById('referrals-buttons');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }, 0);
  };

  const {
    isEditMode,
    setIsEditMode,
    setIsLoading,
    errors,
    setErrors,
    handleErrors,
    renderContent,
    setInitialData,
  } = useFormButtons(
    'section',
    setFormData,
    () => onSubmitHandler(setIsLoading, setIsEditMode, handleErrors),
    formData,
    true,
    'referrals',
  );

  useEffect(() => {
    const data = !_.isEmpty(referrals)
      ? referrals.map((referral) => extractPatientReferral(referral))
      : [];

    setInitialData(data);
    setFormData(data);
  }, [referrals]);

  return (
    <>
      <ReferralsForm
        patientId={patientId}
        isEditMode={isEditMode}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
        patientReferrals={referrals}
        addButtonHandler={onEditHandler}
      />
      <div id="referrals-buttons" className="scroll-m-b-20">
        {renderContent(false, false, onEditHandler)}
      </div>
    </>
  );
};

Referrals.propTypes = {
  patientId: PropTypes.number,
};

export default Referrals;
